import { useResetPagination } from 'hooks/usePaginate';

export const useDashboardItemSelection = () => {
  const { resetPagination } = useResetPagination();

  return { handleItemSelectionSideEffect: resetPagination };
};
